import "./Layout.scss";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import { CiMenuBurger } from "react-icons/ci";
import UserProfile from "./UserProfile";
import { ImCross } from "react-icons/im";
import { FaCircleUser } from "react-icons/fa6";
import { SiHiveBlockchain } from "react-icons/si";
import { MdDashboard } from "react-icons/md";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { INSERT_ACCESS } from "../../_contstants/common";
// import { LuBookPlus } from "react-icons/lu";
// import { GiCommercialAirplane, GiTicket } from "react-icons/gi";
import { RiBookMarkedFill } from "react-icons/ri";
import { GrTransaction } from "react-icons/gr";
import { TbReportSearch, TbWorldWww } from "react-icons/tb";
import { TbReceiptRupee } from "react-icons/tb";
import { LiaInfoSolid } from "react-icons/lia";
import { FaMeta } from "react-icons/fa6";
import { IoMdPersonAdd } from "react-icons/io";
import IconComponent from "../common/IconComponent";
import { FaUser } from "react-icons/fa";
import { LuBookPlus } from "react-icons/lu";
import ChangePasswordDialog from "../../features/ChangePassword/ChangePasswordDialog";

export const menuData = [
  {
    key: "dashboard",
    title: "Dashboard",
    icon: <IconComponent icon={MdDashboard} />,
    quickMenu: [],
    sections: [],
  },

  {
    key: "contact",
    title: "Contact",
    icon: <IconComponent icon={FaUser} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "lead",
    title: "Lead",
    icon: <IconComponent icon={IoMdPersonAdd} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "inquiry",
    title: "Inquiry",
    icon: <IconComponent icon={LiaInfoSolid} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "quotation",
    title: "Quotation",
    icon: (
      <IconComponent icon={TbReceiptRupee} style={{ fill: "transparent" }} />
    ),
    quickMenu: [],
    sections: [],
  },
  {
    key: "fitbooking",
    title: "FIT Booking",
    icon: <IconComponent icon={RiBookMarkedFill} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "booking",
    title: "Booking",
    icon: <IconComponent icon={LuBookPlus} style={{ fill: "transparent" }} />,
    quickMenu: [],
    sections: [],
  },
  // ************************** Hide from Here **************************
  // {
  //   key: "tourbooking",
  //   title: "Booking Form",
  //   icon: <IconComponent icon={LuBookPlus} style={{ fill: "transparent" }} />,
  //   quickMenu: [],
  //   sections: [],
  // },
  // ************************** Hide to Here **************************
  {
    key: "paymentreceipt",
    title: "Payment Receipt",
    icon: <IconComponent icon={GrTransaction} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "masters",
    title: "Masters",
    icon: <IconComponent icon={SiHiveBlockchain} />,
    quickMenu: [
      {
        title: "Add Sector",
        key: "sector/create",
      },
      {
        title: "Add Hotel",
        key: "hotel/create",
      },
      {
        title: "Add Tour",
        key: "tour/create",
      },
      {
        title: "Add Day Wise Itinerary",
        key: "grouproute/create",
      },
    ],
    sections: [
      {
        title: "Place",
        children: [
          {
            title: "Country",
            key: "country",
          },
          {
            title: "State",
            key: "state",
          },
          {
            title: "City",
            key: "city",
          },
          {
            title: "Region",
            key: "region",
          },
          {
            title: "Sector",
            key: "sector",
          },
        ],
      },
      {
        title: "Flight",
        children: [
          {
            title: "Airline",
            key: "airline",
          },
          {
            title: "Airline Class",
            key: "airlineclass",
          },
          // {
          //   title: "Airport",
          //   key: "airport",
          // },
          {
            title: "Flight Place",
            key: "flightplace",
          },
        ],
      },
      {
        title: "Tour Details",
        children: [
          // ************************** Hide from Here **************************
          {
            title: "Speciality Type",
            key: "specialitytype",
          },
          {
            title: "Vehicle Sharing Pax",
            key: "vehiclesharingpax",
          },
          // {
          //   title: "Pax Type",
          //   key: "paxtype",
          // },
          // ************************** Hide to Here **************************
          {
            title: "Food Option",
            key: "foodoption",
          },
          {
            title: "Itinerary",
            key: "itinerary",
          },
          {
            title: "Itinerary Facility",
            key: "itineraryfacility",
          },
          {
            title: "Sightseen",
            key: "sightseen",
          },
          // ************************** Hide from Here **************************
          {
            title: "Day Wise Itinerary",
            key: "grouproute",
          },
          {
            title: "Add Tour",
            key: "tour",
          },
          // ************************** Hide to Here **************************
        ],
      },
      {
        title: "Hotel Details",
        children: [
          {
            title: "Room Type",
            key: "roomtype",
          },
          {
            title: "Room Category",
            key: "roomcategory",
          },
          // ************************** Hide from Here **************************
          // {
          //   title: "Hotel Mapping",
          //   key: "hotelmapping",
          // },
          // ************************** Hide to Here **************************
          {
            title: "Meal Type",
            key: "mealtype",
          },
          {
            title: "Hotel",
            key: "hotel",
          },
        ],
      },
      {
        title: "Visa",
        children: [
          {
            title: "Visa Country",
            key: "visacountry",
          },
          {
            title: "Visa Category",
            key: "visacategory",
          },
          {
            title: "Visa Gateway",
            key: "visagateway",
          },
          {
            title: "Travel Purpose",
            key: "travelpurpose",
          },
          {
            title: "Visa Entry Type",
            key: "visaentrytype",
          },
          {
            title: "Visa Processing Option",
            key: "visaprocessingoption",
          },
          {
            title: "Additional Service",
            key: "additionalservice",
          },
        ],
      },
      {
        title: "Generals",
        children: [
          {
            title: "Admin Setting",
            key: "adminsetting",
          },
          {
            title: "Lead Assign Setting",
            key: "leadassignsetting",
          },
          // ************************** Hide from Here **************************
          // {
          //   title: "WhatsApp Automation Trigger",
          //   key: "autotrigger/whatsapp",
          // },
          // {
          //   title: "Email Automation Trigger",
          //   key: "autotrigger/email",
          // },
          // {
          //   title: "GST",
          //   key: "gst",
          // },
          // ************************** Hide to Here **************************
          {
            title: "Company",
            key: "company",
          },
          {
            title: "Nationality",
            key: "nationality",
          },
          {
            title: "Vendor",
            key: "vendor",
          },
          {
            title: "Vendor Type",
            key: "vendortype",
          },
          {
            title: "Currency",
            key: "currency",
          },
          // ************************** Hide from Here **************************
          // {
          //   title: "Route",
          //   key: "route",
          // },
          // ************************** Hide to Here **************************
          {
            title: "Branch",
            key: "branch",
          },
          {
            title: "Vehicle Type",
            key: "vehicletype",
          },
          // ************************** Hide from Here **************************
          // {
          //   title: "Vehicle",
          //   key: "vehicle",
          // },
          // ************************** Hide to Here **************************
          {
            title: "Lead Source",
            key: "leadsource",
          },
          // ************************** Hide from Here **************************
          // {
          //   title: "Festivals",
          //   key: "festivals",
          // },
          // {
          //   title: "Cancellation Policy",
          //   key: "cancellationpolicy",
          // },
          // {
          //   title: "Agent",
          //   key: "agent",
          // },
          // ************************** Hide to Here **************************
          {
            title: "Terms & Conditions",
            key: "termandcondition",
          },
          {
            title: "Lead Stage",
            key: "leadstage",
          },
          // ************************** Hide from Here **************************
          {
            title: "Brochure",
            key: "brochure",
          },
          {
            title: "Template",
            key: "template",
          },
          // ************************** Hide to Here **************************
          {
            title: "Document",
            key: "document",
          },

          {
            title: "Employment Status",
            key: "employmentstatus",
          },
          {
            title: "Sponsorship Type",
            key: "sponsorshiptype",
          },
          {
            title: "Tour Service",
            key: "tourservice",
          },
          {
            title: "Lost Reason",
            key: "lostreason",
          },
        ],
      },
    ],
  },
  {
    key: "usermanagement",
    title: "User Management",
    icon: <IconComponent icon={FaCircleUser} />,
    quickMenu: [
      { title: "User", key: "user/create" },
      { title: "User Type", key: "usertype/create" },
    ],
    sections: [
      {
        title: "Masters",
        children: [
          /* Always Hidden */
          // { title: "Menu", key: "menu" },
          // { title: "Rights", key: "rights" },
          // { title: "Organization Info", key: "organization" },
          { title: "User", key: "user" },
          { title: "User Type", key: "usertype" },
        ],
      },
    ],
  },

  // ************************** Hide from Here **************************
  // {
  //   key: "block",
  //   title: "Block",
  //   icon: <IconComponent icon={SiHiveBlockchain} />,
  //   quickMenu: [],
  //   sections: [
  //     {
  //       title: "Transctions",
  //       children: [
  //         {
  //           title: "Airline Block",
  //           key: "airlineblock",
  //         },
  //         {
  //           title: "Hotel Block",
  //           key: "hotelblock",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   key: "airlinevoucher",
  //   title: "Airline Ticket",
  //   icon: <IconComponent icon={GiCommercialAirplane} />,
  //   quickMenu: [],
  //   sections: [],
  // },

  // {
  //   key: "voucher",
  //   title: "Voucher",
  //   icon: <IconComponent icon={GiTicket} />,
  //   quickMenu: [],
  //   sections: [
  //     {
  //       title: "Transctions",
  //       children: [
  //         {
  //           title: "Hotel Voucher",
  //           key: "hotelvoucher",
  //         },
  //         {
  //           title: "Route Voucher",
  //           key: "routevoucher",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // ************************** Hide to Here **************************
  {
    key: "reports",
    title: "Reports",
    icon: (
      <IconComponent icon={TbReportSearch} style={{ fill: "transparent" }} />
    ),
    quickMenu: [],
    sections: [
      {
        title: "General",
        children: [
          // ************************** Hide from Here **************************
          // {
          //   title: "Company Wise Booking Report",
          //   key: "companywisebookingreportform",
          // },
          // {
          //   title: "User Wise Tour Booking Report",
          //   key: "userwisetourbookingreportform",
          // },
          // {
          //   title: "Hotel Block Room Status",
          //   key: "hotelblockroomstatusform",
          // },
          // {
          //   title: "Customer Report",
          //   key: "customerreportform",
          // },
          // {
          //   title: "Tour Report",
          //   key: "tourreportform",
          // },
          // {
          //   title: "Tour Booking Invoice",
          //   key: "tourbookinginvoiceform",
          // },
          // {
          //   title: "Airline Excel",
          //   key: "airlineblockview",
          // },
          // {
          //   title: "Ledger Report",
          //   key: "ledgerreportform",
          // },
          // ************************** Hide to Here **************************
          {
            title: "Lead Report",
            key: "leadreportform",
          },
          {
            title: "Inquiry Report",
            key: "inquiryreportform",
          },
          {
            title: "Quotation Report",
            key: "quotationreportform",
          },
          {
            title: "FIT Booking Report",
            key: "fitbookingreportform",
          },
          {
            title: "Booking Summary Report",
            key: "bookingsummaryreportform",
          },
          {
            title: "Revenue Generated By User Report",
            key: "revenuegeneratedbyUserreportform",
          },
          {
            title: "Inquiry Conversion Report",
            key: "inquiryconversionreportform",
          },
          {
            title: "Destination Wise Performance Report",
            key: "destinationwiseperformancereportform",
          },
          {
            title: "Lead Source Analysis Report",
            key: "leadsourceanalysisreportform",
          },
          {
            title: "User Performance Report",
            key: "userperformancereportform",
          },
          {
            title: "Quotation Status Report",
            key: "quotationstatusreportform",
          },
          {
            title: "Profitability Report",
            key: "profitabilityreportform",
          },
          {
            title: "Pending Inquiry Follow-Up Report",
            key: "pendingInquiryfollowupreportform",
          },
          {
            title: "Lost Inquiry Analysis Report",
            key: "lostinquiryanalysisreportform",
          },
          {
            title: "Monthly Revenue Trend Report",
            key: "monthlyrevenuetrendreportform",
          },
          {
            title: "Upcoming Departure Data Report",
            key: "UpcomingDepartureDataReportform",
          },
          {
            title: "Customer Retention Report",
            key: "customerretentionreportform",
          },
          {
            title: "GST & Tax Summary Report",
            key: "gstandtaxsummaryreportform",
          },
          {
            title: "Service-Type Revenue Report",
            key: "servicetyperevenuereportform",
          },
          {
            title: "Follow-Up Efficiency Report",
            key: "followupefficiencyreportform",
          },
          {
            title: "Daily Performance Snapshot",
            key: "dailyperformancesnapshotreportform",
          },
          {
            title: "Promocode Wise Usage Report",
            key: "promocodeusagereportform",
          },
        ],
      },
    ],
  },
  {
    key: "integrations",
    title: "Integrations",
    icon: <IconComponent icon={FaMeta} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "webintegrations",
    title: "Web Integrations",
    icon: <IconComponent icon={TbWorldWww} />,
    quickMenu: [],
    sections: [
      {
        title: "Website",
        children: [
          {
            title: "Testimonial",
            key: "testimonial",
          },
          {
            title: "Seo Tag",
            key: "seotag",
          },
          {
            title: "Banner",
            key: "banner",
          },
          {
            title: "CMS",
            key: "cms",
          },
          {
            title: "Setting",
            key: "setting",
          },
          {
            title: "Blog",
            key: "blog",
          },
          {
            title: "FAQ",
            key: "faq",
          },
          {
            title: "Client",
            key: "client",
          },
          {
            title: "Web Branch",
            key: "webbranch",
          },
          {
            title: "Instagram Story",
            key: "instagramstory",
          },
          {
            title: "Community",
            key: "community",
          },
          {
            title: "Activity",
            key: "activity",
          },
          {
            title: "Weekend Gateways",
            key: "weekendgateways",
          },
          {
            title: "Coupon Code",
            key: "couponcode",
          },
          {
            title: "Section",
            key: "section",
          },
          {
            title: "Designation",
            key: "designation",
          },
          {
            title: "Career",
            key: "career",
          },
          {
            title: "Newsletter",
            key: "newsletter",
          },

          // ************************** Hide from Here **************************
          // {
          //   title: "Useful Links",
          //   key: "usefullinks",
          // },
          // {
          //   title: "Service",
          //   key: "service",
          // },

          // ************************** Hide to Here **************************
        ],
      },
    ],
  },
];

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMasterUser = localStorage.getItem("IsMasterUser") === "true";

  const MENUNAME = [
    "dashboard",
    "contact",
    "lead",
    "inquiry",
    "quotation",
    "fitbooking",
    "tourbooking",
    "booking",
  ];

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userRights: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userRights = JSON.parse(userResponseString);
  } catch (error) {
    userRights = [];
  }

  const filterMenuByUserRights = (menuData: any, userRights: any) => {
    const hasRight = (key: string) => {
      if (key.includes("/create")) {
        const baseKey = key.replace("/create", "");
        const userMenu = userRights?.find(
          (menu: any) => menu.MenuKey === baseKey,
        );
        return (
          userMenu && userMenu.RightsID.split(", ").includes(INSERT_ACCESS)
        );
      } else {
        return userRights?.some((menu: any) => menu.MenuKey === key);
      }
    };

    return menuData
      .map((menu: any) => {
        const mainMenuHasRight = hasRight(menu.key);

        if (!mainMenuHasRight) return null;

        const filteredQuickMenu = menu.quickMenu.filter((item: any) =>
          hasRight(item.key),
        );
        const filteredSections = menu.sections
          .map((section: any) => {
            const filteredChildren = section.children.filter((child: any) =>
              hasRight(child.key),
            );
            return { ...section, children: filteredChildren };
          })
          .filter((section: any) => section.children.length > 0);
        if (
          hasRight(menu.key) ||
          filteredQuickMenu.length > 0 ||
          filteredSections.length > 0
        ) {
          return {
            ...menu,
            quickMenu: filteredQuickMenu,
            sections: filteredSections,
          };
        }
        return null;
      })
      .filter((menu: any) => menu !== null);
  };

  const filteredMenus = filterMenuByUserRights(menuData, userRights);

  const usermanagementIndex = filteredMenus.findIndex(
    (item: any) => item.key === "usermanagement",
  );
  if (usermanagementIndex !== -1 && isMasterUser) {
    filteredMenus[usermanagementIndex].sections[0].children.push(
      { title: "Menu", key: "menu" },
      { title: "Rights", key: "rights" },
      { title: "Organization Info", key: "organization" },
    );
  }

  const { pathname } = location;
  const baseKey = pathname?.split("/").filter(Boolean)[0] || "";

  const toggleMenu = () => {
    document.querySelectorAll(".navbar-nav > li").forEach((element) => {
      element.addEventListener("click", function (this: HTMLElement) {
        document.querySelector(".page-contect")?.classList.remove("in");
        document.querySelectorAll(".navbar-nav > li").forEach((li) => {
          li.classList.remove("active");
          const popup = document.querySelector(
            ".navbar-nav > li.active .subnav-content",
          );
          if (popup) {
            const popupElement = popup as HTMLElement;
            popupElement.classList.remove("d-block");
            popupElement.classList.add("d-none");
          }
        });
        this.classList.add("active");
        const popup = document.querySelector(
          ".navbar-nav > li.active .subnav-content",
        );
        if (popup) {
          const popupElement = popup as HTMLElement;
          popupElement.classList.remove("d-none");
          popupElement.classList.add("d-block");
        }
      });
    });
  };

  useEffect(() => {
    toggleMenu();
  }, []);

  const toggleSubMenu = () => {
    const popup = document.querySelector(
      ".navbar-nav > li.active .subnav-content",
    );
    if (popup) {
      const popupElement = popup as HTMLElement;
      popupElement.classList.remove("d-block");
      popupElement.classList.add("d-none");
    }

    document.querySelectorAll(".navbar-nav > li").forEach((li) => {
      li.classList.remove("active");
    });
  };

  const toggleNav = () => {
    const sidenav = document.querySelector(".side-nav") as any;
    const mbottom = document.querySelector(".m-bottom") as any;
    const ainavbarheader = document.querySelector(".ainavbar-header") as any;
    const pagewrapper =
      document.querySelector(".page-wrapper") ||
      (document.querySelector(".dashboard-page-wrapper") as any);
    const pagecontect = document.querySelectorAll(".page-contect") as any;
    const menuName = document.querySelectorAll(".menu-name") as any;
    const greaterThan = document.querySelector(".greaterthan") as any;
    const lessThan = document.querySelector(".lessthan") as any;
    const headerTitle = document.querySelector(".header-title") as any;

    const isOpen = sidenav.style.width === "210px";
    const isHeaderOpen = ainavbarheader.style.width === "210px";
    headerTitle.style.setProperty("--content", isOpen ? '"AI"' : '"AICRM"');
    sidenav.style.width = isOpen ? "60px" : "210px";
    mbottom.style.width = isOpen ? "60px" : "210px";
    pagewrapper.style.marginLeft = isOpen ? "60px" : "210px";
    ainavbarheader.style.width = isHeaderOpen ? "60px" : "210px";
    pagecontect.forEach((element: any) => {
      if (isOpen) {
        element.style.left = "60px";
      } else {
        element.style.left = "210px";
      }
    });
    menuName.forEach((element: any) => {
      if (isOpen) {
        element.style.transition = "0.5s";
        element.classList.remove("d-inline");
        element.classList.add("d-none");
      } else {
        element.style.transition = "0.5s";
        element.classList.remove("d-none");
        element.classList.add("d-inline");
      }
    });
    if (isOpen) {
      lessThan.classList.remove("d-block");
      lessThan.classList.add("d-none");
      greaterThan.classList.remove("d-none");
      greaterThan.classList.add("d-block");
    } else {
      lessThan.classList.remove("d-none");
      lessThan.classList.add("d-block");
      greaterThan.classList.remove("d-block");
      greaterThan.classList.add("d-none");
    }
  };

  const handleNavigate = (url: string) => {
    if (url) {
      toggleSubMenu();
      navigate(`${url}`);
    }
  };

  return (
    <>
      <ChangePasswordDialog />
      <div id="wrapper">
        <nav className="ainavbar" role="navigation">
          <div className="ainavbar-header" style={{ width: 210 }}>
            <button type="button" className="navbar-toggle">
              <IconComponent icon={CiMenuBurger} />
            </button>
            <h3 className="m-0 header-title"></h3>
          </div>
          <div className="d-flex align-items-center">
            <UserProfile />
          </div>
        </nav>
        <div className="collapse navbar-collapse navbar-ex1-collapse show">
          <ul
            className="nav navbar-nav side-nav"
            style={{ zIndex: 10, scrollbarWidth: "none", width: 210 }}
          >
            {filteredMenus.map((menu: any, index: any) => {
              const lastKey = MENUNAME?.slice()
                ?.reverse()
                ?.find((key: any) =>
                  filteredMenus?.some((m: any) => m?.key === key),
                );

              let isActive = menu?.key === baseKey;

              if (
                !isActive &&
                Array.isArray(menu?.quickMenu) &&
                menu?.quickMenu?.length > 0
              ) {
                isActive = menu?.quickMenu?.some(
                  (q: any) => q?.key === baseKey,
                );
              }

              if (
                !isActive &&
                Array.isArray(menu?.sections) &&
                menu?.sections?.length > 0
              ) {
                isActive = menu?.sections?.some(
                  (section: any) =>
                    Array.isArray(section?.children) &&
                    section?.children?.some(
                      (child: any) => child?.key === baseKey,
                    ),
                );
              }

              return (
                <li
                  className={`subnav ${isActive ? "active" : ""}`}
                  key={index}
                  onClick={toggleMenu}
                  style={{
                    marginBottom: filteredMenus?.length - 1 === index ? 55 : 0,
                    borderBottom:
                      menu.key === lastKey ? "1px solid lightgray" : "none",
                  }}
                >
                  <p
                    className="collapsed"
                    onClick={() =>
                      menu.key === "dashboard"
                        ? navigate("/")
                        : menu.quickMenu?.length < 1 &&
                            menu.sections?.length < 1
                          ? navigate(`/${menu?.key}`)
                          : null
                    }
                  >
                    <Tooltip
                      anchorElement="target"
                      position="right"
                      parentTitle={true}
                    >
                      <span title={menu.title} className="m-0">
                        {menu.icon}
                        <span className="menu-name">{menu.title || ""}</span>
                      </span>
                    </Tooltip>
                  </p>
                  {(menu.quickMenu?.length > 0 ||
                    menu.sections?.length > 0) && (
                    <div className="subnav-content page-contect">
                      <div className="container-fluid pb-3">
                        <div className="container-title">
                          <h2 className="fw-600">{menu.title} - Quick Menu</h2>
                          <button
                            className="model-close"
                            onClick={toggleSubMenu}
                          >
                            <IconComponent icon={ImCross} />
                          </button>
                        </div>
                        {menu.quickMenu?.length > 0 && (
                          <div className="quick-menu">
                            <div className="quick-menu-cards">
                              {menu.quickMenu.map((item: any) => (
                                <div
                                  key={item.key}
                                  className="quick-menu-card"
                                  onClick={() => handleNavigate(item.key)}
                                >
                                  <h5>{item.title}</h5>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        <div className="section-list">
                          {menu.sections?.map(
                            (section: any) =>
                              section.children?.length > 0 && (
                                <div key={section.title} className="section">
                                  <h4>{section.title}</h4>
                                  <ul>
                                    {section.children.map((child: any) => (
                                      <Tooltip
                                        key={child.key}
                                        anchorElement="target"
                                        position="top"
                                        parentTitle={true}
                                      >
                                        <li
                                          key={child.key}
                                          title={child.title}
                                          onClick={() =>
                                            handleNavigate(child.key)
                                          }
                                        >
                                          {child.title}
                                        </li>
                                      </Tooltip>
                                    ))}
                                  </ul>
                                </div>
                              ),
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
            <div className="m-bottom" onClick={toggleNav}>
              <span className="m-arrow">
                <IconComponent
                  icon={FaGreaterThan}
                  className="greaterthan d-none cursor-pointer"
                />
                <IconComponent
                  icon={FaLessThan}
                  className="lessthan cursor-pointer"
                />
              </span>
            </div>
          </ul>
        </div>
        {location.pathname === "/" ? (
          <div className="all-page">
            <div className="dashboard-page-wrapper">
              <Outlet />
            </div>
          </div>
        ) : (
          <div className="all-page">
            <div className="page-wrapper">
              <div className="page-information ">
                <Outlet />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Layout;
